var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('pageheader',{staticClass:"head-view",attrs:{"userTypeName":_vm.userTypeName},on:{"changeUserType":_vm.changeUserType}}),(_vm.showType == 0)?_c('LoginView',{staticClass:"login-view",on:{"changeShowType":_vm.changeShowType,"towxlogin":_vm.toWxLogin}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }